import { render, staticRenderFns } from "./ViewOrderCard.vue?vue&type=template&id=b5a97094&"
import script from "./ViewOrderCard.vue?vue&type=script&lang=ts&"
export * from "./ViewOrderCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QCardActions})
